<template>
  <div class="financial-selector__banks">
    <div
      v-show="!searching"
      class="financial-selector__banks-list"
    >
      <div class="font-heading text-lg font-bold my-2 ml-[6px]">
        Most popular banks
      </div>
      <div class="grid grid-cols-2 sm:grid-cols-5">
        <div
          v-for="(bank, index) in banks"
          :key="index"
          class="financial-selector__banks-item"
          :class="{
            'financial-selector__banks-item__hidden': bank.hideDesktop}"
          :style="{'--button-background-color': bank.bgColor, '--button-background-color--hover': bank.bgColorHover}"
          @click="handleBankSelect(bank, 'icon')"
        >
          <img
            class="w-50 h-50 mt-20 flex-1"
            :src="bank.image"
          >
          <p class="text-xs flex-1 mt-10 font-semibold text-center md:leading-xs">
            {{ bank.name }}
          </p>
        </div>
      </div>
    </div>
    <div v-show="searching">
      <div
        v-if="!stickySearchBar"
        class="bg-white px-30 max-w-700 mx-auto mt-5"
      >
        <div
          v-for="(bank, index) in filteredInstitutions"
          :key="index"
          class="py-20 cursor-pointer"
          @click="handleSelect(bank)"
        >
          {{ bank.name }}
        </div>
        <div v-if="searchText">
          <div
            v-if="filteredInstitutions.length===0"
            class="py-20 text-[#707475] text-md"
          >
            No matches found. Try searching with the full bank name.
          </div>
          <hr>
          <div
            class="flex items-center justify-between py-20 cursor-pointer"
            @click="triggerChat()"
          >
            <div class="flex gap-4">
              <div class="flex items-center">
                <img
                  class="mx-auto h-[33px]"
                  :src="require('@/assets/svg/chat-logo.svg')"
                  alt="chat logo"
                >
              </div>
              <div class="flex flex-col">
                <span>Can’t find your bank?</span>

                <span><b>Chat with an agent.</b></span>
              </div>
            </div>
            <div>
              <FontAwesomeIcon
                icon="chevron-right"
                class="text-base font-bold"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <FreshChat
      :hide-chat-button="true"
      :load-chat="loadChat"
      @close-chat="loadChat = false"
    />
  </div>
</template>

<script>
import FreshChat from '@/components/widgets/freshchat/FreshChat'
import chatHandler from '@/mixins/freshchat/chat-handler'
export default {
  name: 'FinancialSelectorBanks',
  components: {
    FreshChat
  },

  mixins: [
    chatHandler
  ],
  props: {
    banks: {
      type: Array,
      required: true
    },
    searching: {
      type: Boolean,
      default: false
    },
    stickySearchBar: {
      type: Boolean,
      default: false
    },
    filteredInstitutions: {
      type: Array,
      default: () => []
    },
    handleBankSelect: {
      type: Function,
      default: () => {}
    },
    handleSelect: {
      type: Function,
      default: () => {}
    },
    searchText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang=scss scoped>

.financial-selector__banks {
  @apply h-1200 sm:h-500;

  &-list {
    @apply mt-20 max-w-500 sm:max-w-750 mx-auto mb-35;
  }

  &-item {
    @apply border-2 cursor-pointer px-5 m-5 w-160 h-130 sm:w-125 mx-auto sm:h-125 md:w-140;
    @apply flex flex-col justify-center items-center rounded-5 cursor-pointer;

    background-color: var(--button-background-color);

    &:hover {
      background-color: var(--button-background-color--hover);

      @apply text-white;
    }

    &__hidden {
      @screen sm {
        @apply hidden;
      }
    }
  }
}
</style>
